{
  "account_disabled": "This account is disabled.",
  "adjustment_conflict": "This Idempotency-Key was already used for another adjustment.",
  "amount_out_of_range": "A top-up must be between {{min}} and {{max}} credits.",
  "authentication_required": "You must sign in to do this.",
  "banned_required": "The 'banned' field is required.",
  "batch_not_found": "This send does not exist.",
  "batch_not_listed": "The batch in the filters is not one of the caller's.",
  "billing_provider_local": "Plans are purchased through the wallet on this deployment.",
  "blank_message": "The message cannot be blank.",
  "callback_rejected": "The notification was rejected.",
  "credit_note_not_found": "Credit note not found.",
  "customer_permission_not_allowed": "A staff-only permission cannot be granted to a customer account.",
  "deletion_already_requested": "An account deletion was already requested.",
  "delivery_host_not_allowed": "The delivery URL's host is not allowed: it must be public.",
  "delivery_not_found": "This webhook delivery does not exist.",
  "delivery_not_retryable": "Only a delivery given up less than a month ago can be retried.",
  "delivery_url_not_https": "The delivery URL must use https.",
  "delivery_url_scheme": "The delivery URL must use http or https.",
  "device_limit_reached": "Your plan allows up to {{deviceLimit}} active devices and you have {{activeDeviceCount}}. Disable or delete another device, or upgrade your plan.",
  "device_not_enabled": "This device does not exist or is not enabled.",
  "device_not_exist": "This device does not exist (v1 only).",
  "device_not_found": "The device does not exist, or is not the caller's.",
  "device_not_listed": "A device in the filters is not one of the caller's.",
  "email_not_verified": "Verify your email address before asking for a refund.",
  "email_taken": "An account already exists for this email address.",
  "enabled_required": "The 'enabled' field is required.",
  "expires_at_required": "A bank transfer needs its deadline.",
  "google_token_invalid": "Google sign-in could not be verified.",
  "idempotency_in_flight": "The previous request with this key is still in progress.",
  "idempotency_key_invalid": "The idempotency key is invalid.",
  "idempotency_key_required": "The idempotency key is missing.",
  "idempotency_key_reuse": "This idempotency key was already used with a different request.",
  "idempotency_lock_lost": "Another attempt took over this idempotency key in the meantime.",
  "idempotency_response_unavailable": "The previous request's response is no longer available.",
  "illegal_transition": "This payment cannot move to that status.",
  "insufficient_funds": "The wallet does not hold enough credit for this debit.",
  "internal_error": "An internal error occurred.",
  "invalid_adjustment": "The amount must be a non-zero whole number of at most {{max}} either way; a promotional grant must be positive.",
  "invalid_amount": "The amount must be between {{min}} and {{max}} credits.",
  "invalid_body": "The request body is invalid.",
  "invalid_category": "Choose a valid category.",
  "invalid_credentials": "The email or password is incorrect.",
  "invalid_cursor": "The pagination cursor is invalid.",
  "invalid_custom_limit": "A custom limit must be -1 (unlimited) or a whole number of zero or more.",
  "invalid_custom_range": "The period must start before it ends and span at most 366 days.",
  "invalid_day": "day must be a date written YYYY-MM-DD.",
  "invalid_delivery_url": "The delivery URL is invalid.",
  "invalid_device_id": "This device identifier is invalid.",
  "invalid_effect": "The effect must be grant or revoke.",
  "invalid_email": "The email address is invalid.",
  "invalid_event": "Invalid event type.",
  "invalid_filter": "This filter cannot be read. Check the fields listed.",
  "invalid_id": "This identifier is invalid.",
  "invalid_interval": "interval must be 'month' or 'year'.",
  "invalid_key": "The API key or access token is invalid.",
  "invalid_message_list": "Give at least one message with text and recipients.",
  "invalid_message_query": "The message filters are invalid: {{reason}}",
  "invalid_name": "The name must contain between 1 and 100 characters.",
  "invalid_overage_cap": "A monthly cap must be at least one pack ({{min}} FCFA).",
  "invalid_plan": "This plan is not valid. Check the fields listed.",
  "invalid_price_version": "This price list cannot be published. Check the fields listed.",
  "invalid_email_preferences": "Send both preferences, usage alerts and credit warnings, on or off.",
  "invalid_page": "A page needs a title and a text in at least one language, within the size limit.",
  "invalid_profile": "The name must be 1 to 100 characters, the phone at most 32, and the language fr or en.",
  "invalid_range": "from and to are required: dates (YYYY-MM-DD, WAT) or RFC 3339 instants, from before to, at most {{days}} days apart.",
  "invalid_reason": "The reason must be {{min}} to {{max}} characters.",
  "invalid_recipients": "Give at least one recipient.",
  "invalid_recurring_interval": "recurringInterval must be 'month' or 'year'.",
  "invalid_role_input": "The role's slug, names or tier are invalid.",
  "invalid_schedule": "scheduledAt must be a valid ISO 8601 date.",
  "invalid_setting": "This value cannot be saved. Check the fields listed.",
  "invalid_signing_secret": "The signing secret must be at least 20 characters long.",
  "invalid_status": "The status filter is not one the list accepts.",
  "invalid_subscription_id": "This webhook subscription identifier is invalid.",
  "invalid_user_id": "This user identifier is invalid.",
  "invite_requires_staff_role": "An invitation must use a staff role, not a customer role.",
  "invoice_not_found": "Invoice not found.",
  "invoice_not_paid": "This invoice is not paid yet.",
  "invoice_paid": "This invoice is already paid.",
  "invoice_void": "This invoice was cancelled.",
  "job_not_discarded": "Only a discarded job can be retried.",
  "job_not_found": "This job does not exist, or was removed 14 days after it ended.",
  "job_superseded": "Another job already does this work, so this one cannot be retried.",
  "last_super_admin": "This is the last active super administrator and cannot be demoted, banned or deleted.",
  "limit_exceeded": "The send would pass the plan's daily, monthly or bulk limit.",
  "malformed_received_sms": "The received SMS is malformed (v1 only).",
  "message_required": "Enter your message.",
  "message_too_long": "Your message must be at most 5000 characters.",
  "method_unavailable": "This payment method is not available.",
  "msisdn_invalid": "This phone number cannot be charged. Use a Cameroonian mobile number (237 6XX XX XX XX).",
  "name_control_chars": "Your name contains characters that are not allowed.",
  "name_required": "Enter your name.",
  "name_too_long": "Your name must be at most 100 characters.",
  "no_enabled_device": "No device is enabled. Enable a device or choose one to send from.",
  "no_events": "Choose at least one event to receive.",
  "not_found": "The API key or device does not exist, or is not the caller's.",
  "not_revoked": "Revoke this API key before deleting it.",
  "nothing_to_change": "The request asks for no change.",
  "notice_finished": "This notice was already sent or recorded as failed; retrying its job would not send it again.",
  "otp_invalid": "The reset code is invalid or has expired.",
  "overage_pack_closed": "The extra SMS pack covering this send has just closed. Send again.",
  "override_not_found": "This user has no override for that permission.",
  "password_hash_busy": "Too many sign-ins are being checked at once. Try again in a moment.",
  "payload_too_large": "The request body exceeds the allowed size.",
  "payment_already_credited": "This payment's money was already credited, by its own top-up or a late one.",
  "payment_amount_mismatch": "The operator reported another amount; the payment is held for review.",
  "payment_exists": "A payment already exists for this top-up.",
  "payment_creditable": "The payment can still settle its own top-up: resolve it with credit, not credit_as_topup.",
  "payment_initiation_in_progress": "The payment is still being initiated with the operator.",
  "payment_needs_review": "The payment is waiting for a person; do not pay again.",
  "payment_not_expired": "The payment has not expired, so it cannot be closed as expired.",
  "payment_not_found": "No such payment.",
  "payment_not_in_review": "The payment is not waiting for a person, so there is nothing to resolve.",
  "page_not_found": "This page does not exist, or has not been written yet.",
  "page_version_conflict": "Someone published this page meanwhile. Reload it, check their version, and publish again.",
  "permission_denied": "You are not allowed to do this.",
  "phone_control_chars": "Your phone number contains characters that are not allowed.",
  "phone_too_long": "Your phone number must be at most 32 characters.",
  "plan_already_active": "You already have this plan for this interval.",
  "plan_id_required": "planId is required.",
  "plan_inactive": "This plan is not active.",
  "plan_name_locked": "This plan has been priced, so its name can no longer change.",
  "plan_name_taken": "Another plan already has this name.",
  "plan_not_for_sale": "This plan cannot be bought for this interval.",
  "plan_not_found": "This plan does not exist.",
  "plan_required": "The free plan cannot be retired: every ended subscription falls back to it.",
  "polled_too_recently": "Pending messages were fetched less than 5 minutes ago. Try again later.",
  "price_version_not_found": "This price version does not exist.",
  "privilege_escalation": "You cannot grant access beyond your own, or act on an account with more access than yours.",
  "proof_invalid": "The proof was refused. Upload a PDF, JPEG or PNG file of at most 5 MB, exactly as declared.",
  "provider_unavailable": "The operator could not be reached. Your payment has not failed; we are checking it.",
  "quote_not_found": "This quote has expired or does not exist. Ask for a new one.",
  "quote_plan_mismatch": "This quote is for another plan.",
  "quote_stale": "Your subscription or the prices changed since this quote. Ask for a new one.",
  "rate_limited": "Too many requests. Please try again later.",
  "reason_required": "A reason is required.",
  "reassign_to_self": "Choose a different role to reassign these users to.",
  "reconciliation_report_not_found": "No reconciliation report for that day.",
  "recovery_off": "Message recovery is switched off for this device.",
  "recovery_old_version": "This app version cannot recover messages.",
  "refresh_reused": "This session was used from somewhere else and has been closed. Please sign in again.",
  "refund_destination_invalid": "The destination is not one the quote offered, or a bank account is missing a detail.",
  "refund_fee_invalid": "The operator's fee must be at least 0 and less than the refund's gross.",
  "refund_not_found": "No refund with this id for this account.",
  "refund_out_of_range": "The amount must be between {{min}} and {{max}} credits.",
  "refund_pending": "A refund request is already open for this account.",
  "refund_reviewed": "The refund is not in a state this step accepts.",
  "report_not_found": "This report does not exist.",
  "request_invalid": "The request does not match the contract; check the fields listed.",
  "reserved_plan_name": "The free plan and custom plans cannot be created or renamed here.",
  "role_in_use": "This role is still held by at least one user. Choose a role to reassign them to.",
  "role_is_system": "This role is built in and cannot be changed or deleted.",
  "role_not_found": "The role does not exist.",
  "role_slug_taken": "A role with this slug already exists.",
  "schedule_in_past": "scheduledAt must be in the future.",
  "service_unavailable": "The service is temporarily unavailable. Please try again shortly.",
  "session_invalid": "Your session has ended. Please sign in again.",
  "session_not_found": "This session does not exist or has already ended.",
  "setting_not_found": "This setting does not exist.",
  "setting_version_conflict": "This setting was changed since you read it. Reload it and try again.",
  "sms_not_found": "This message does not exist.",
  "sms_other_device": "The message belongs to another device.",
  "staff_account_override": "Staff accounts always manage their own profile and security, so this permission cannot be overridden for them.",
  "standalone_disabled": "This action is disabled on this deployment. Ask an administrator.",
  "stats_bucket": "Only daily buckets are supported (bucket=day).",
  "stats_range": "The period must start before it ends and span at most 366 days.",
  "step_up_required": "Confirm your identity again to do this.",
  "subscription_active_wallet": "This user has an active paid subscription; pass override to replace it.",
  "subscription_not_found": "No such subscription.",
  "super_admin_override": "A super administrator's permissions cannot be overridden individually.",
  "token_invalid": "This link is invalid, has expired or was already used.",
  "too_many_emails": "Too many emails were requested. Please try again tomorrow.",
  "too_many_recipients": "Too many recipients: send at most {{max}} per request.",
  "topup_closed": "The top-up is already settled, failed or expired.",
  "topup_not_found": "No top-up with this id for this account.",
  "topup_rate_limited": "Too many top-up attempts for this account or number; try again later.",
  "totp_enrolment_required": "Set up two-factor authentication before using the administration area.",
  "totp_invalid": "The verification code is invalid or has expired.",
  "totp_required_for_staff": "Two-factor authentication is mandatory for staff accounts and cannot be turned off.",
  "transfer_expired": "The transfer expired unproven; start a new top-up.",
  "transfer_not_found": "No bank transfer with this id for this account.",
  "transfer_not_submitted": "The transfer has no proof yet, so it cannot be reviewed.",
  "transfer_overpaid": "More was received than the invoice total; nothing was written.",
  "transfer_reviewed": "The transfer was already reviewed.",
  "turnstile_failed": "The anti-robot check failed. Please try again.",
  "unauthorized": "You must sign in to do this.",
  "unknown_permission": "This permission does not exist.",
  "user_deleted": "This account was deleted and cannot be restored.",
  "user_not_found": "This user does not exist.",
  "weak_password": "The password must be between 8 and 128 characters.",
  "webhook_limit": "You can create at most {{max}} webhook subscriptions."
}
